module.exports = __webpack_public_path__ + "02_face.c7325c6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer1/02_face.png
// module id = VxcQ
// module chunks = 0